export default __webpack_public_path__ + "static/153-d3e5462603481d1574a367da3fc4704f.jpg";